module.exports = __webpack_public_path__ + "uganda.svg?e76a6f8589efd3eb91128f0c10f06c69";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/uganda.svg
// module id = 328
// module chunks = 10